// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const SalesOrderRefundStatus = {
  PartialRefund: {
    Name: 'Partial Refund',
    Value: 'partial_refund',
    Icon: 'Undo',
    Variant: 'warning',
  },
  Refunded: {
    Name: 'Refunded',
    Value: 'refunded',
    Icon: 'Undo2',
    Variant: 'destructive',
  },
} as const

export type SalesOrderRefundStatusValue =
  (typeof SalesOrderRefundStatus)[keyof typeof SalesOrderRefundStatus]['Value']
